'use strict';

angular.module('ClinicApp').directive('photoViewer', function() {
  return {
    templateUrl: '/views/directives/_photo-viewer.html',
    scope: {
      photos: '=',
      onClose: '&',
      currentIndex: '=',
      isInsurance: '=',
    },
    link: function(scope) {
      scope.currentIndex = scope.currentIndex || 0;

      scope.setCurrentPhoto = function(index, e) {
        e.stopPropagation();
        scope.currentIndex = index;
      };

      scope.next = function() {
        if (scope.currentIndex == scope.photos.length - 1) {
          scope.currentIndex = 0;
        } else {
          scope.currentIndex++;
        }
      };

      scope.previous = function() {
        if (scope.currentIndex === 0) {
          scope.currentIndex = scope.photos.length - 1;
        } else {
          scope.currentIndex--;
        }
      };

      scope.stopPropagation = function(e) {
        e.stopPropagation();
      };

      var keyHandler = function(e) {
        switch (e.originalEvent.keyCode) {
          case 27: // esc
            scope.onClose();
            scope.$apply();
            break;
          case 37: // left
            scope.previous();
            scope.$apply();
            break;
          case 39: // right
            scope.next();
            scope.$apply();
            break;
        }
      };

      var $doc = angular.element(document);

      $doc.on('keydown', keyHandler);
      scope.$on('$destroy', function() {
        $doc.off('keydown', keyHandler);
      });
    },
  };
});
